import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import Support from '../../shared/Support';
import useRouteStatus from '../../../hooks/useRouteStatus';
import useSessionEntity from '../../../hooks/useSessionEntity';
import useSession from '../../../hooks/useSession';
import Default from './approved/Default';
import Recharge from './approved/Recharge';

export default function Approved({ location }) {
  const [session, sessionActions] = useSession();
  const merchant = useSessionEntity('merchant');
  const isRecharge = session.hasCustomFlag('recharge');

  useRouteStatus(location);

  useEffect(() => {
    sessionActions.finish();
  }, []);

  return (
    <div id="content" className="has-text-centered">
      {isRecharge && <Recharge merchant={merchant} />}
      {!isRecharge && <Default merchant={merchant} />}
    </div>
  );
}
